import { styled } from '@mui/material';
import { Box } from 'shared/mui/Box';

export const WrapperStyled = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  boxSizing: 'border-box',
  padding: '8px 16px',
  cursor: 'pointer',
  borderBottom: `1px solid ${theme.palette.divider}`,
  '&:hover': {
    backgroundColor: 'rgba(25, 118, 210, 0.08)',
  },
}));

export const ContentStyled = styled(Box)({
  width: '366px',
});

export const SubContentStyled = styled(Box)({
  display: 'flex',
  gap: '4px',
});

export const ActionStyled = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  marginLeft: 'auto',
});
